/**
 *
 * @param {Object} GlobalStore - The GlobalStore instance
 * @param {Object} flagrEvaluation - A Flagr evaluation result
 * @param {Object} STORE_ACTIONS - Store actions enumerable
 * @param {Object} FLAGR_FEATURE_KEYS - Flagr keys enumerable
 */
const saveToStore = (GlobalStore, flagrEvaluation, STORE_ACTIONS, FLAGR_FEATURE_KEYS) => {
	const flagResults = {};
	Object.keys(FLAGR_FEATURE_KEYS).forEach((i) => {
		flagResults[FLAGR_FEATURE_KEYS[i]] = false;
	});
	if (flagrEvaluation && flagrEvaluation.length) {
		flagrEvaluation.forEach((evalObject) => {
			flagResults[evalObject.flagKey] = ['enabled', 'true', 'on'].includes(evalObject.variantKey)
				? true
				: false;
		});
	}

	GlobalStore.dispatch(
		STORE_ACTIONS.setFlagrEvaluation({
			features: flagResults,
			flagrResults: flagrEvaluation,
		})
	);
};

/**
 *
 * @param {Array} userRoles - List of current user roles
 * @param {Object} customerData  - The customer info for the current user
 * @param {Object} ENUMS - An object of Enumerables
 */

export const getFlagrPromise = (userRoles, customerData, ENUMS) => {
	const { USER_ROLES, FLAGR_KEYS } = ENUMS;

	// Generate a key-value map of user role permissions
	const roleMapping = {};
	Object.entries(USER_ROLES).forEach(([key, value]) => {
		if (userRoles.includes(value)) {
			roleMapping[key] = true;
		} else {
			roleMapping[key] = false;
		}
	});
	return API.POST(
		`${process.env.FLAGR_ENDPOINT}/api/v1/evaluation/batch`,
		JSON.stringify({
			entities: [
				{
					entityContext: {
						customerId: customerData.id,
						customer: customerData.canonical_name,
						environment: process.env.NODE_ENV,
						userEmail: customerData.user_email,
						isTrial: customerData.is_self_service,
						...roleMapping,
					},
					entityType: 'app',
					timeoutPeriod: 1500,
				},
			],
			flagKeys: FLAGR_KEYS.app,
		}),
		{
			headers: { 'Content-Type': 'application/json' },
		}
	);
};

export const setupFlagr = (flagrResponse, GlobalStore, ENUMS) => {
	const { FLAGR_FEATURE_KEYS, STORE_ACTIONS } = ENUMS;

	try {
		const { evaluationResults: flagResults } = flagrResponse.data;

		// Save evaluation results to global store
		saveToStore(GlobalStore, flagResults, STORE_ACTIONS, FLAGR_FEATURE_KEYS);

		window.mixpanel.track('app_flagr_evaluation');

		try {
			// Keep Flagr response in local storage for future use should Flagr be unavailable
			localStorage.setItem('lastFlagrEvaluation', JSON.stringify(flagResults));
		} catch (err) {
			window.mixpanel.track('app_flagr_evaluation_fail_storage');
			Sentry.captureException(err);
		}
	} catch (err) {
		/**
		 * Attempt to retrieve and restore last saved evaluation from locastorage.
		 */
		window.mixpanel.track('app_flagr_error');
		const flagResults = localStorage.getItem('lastFlagrEvaluation');

		if (flagResults) {
			saveToStore(GlobalStore, JSON.parse(flagResults), STORE_ACTIONS, FLAGR_FEATURE_KEYS);
			window.mixpanel.track('app_flagr_restore_from_storage');
		} else {
			// If localstorage is empty, set empty store values
			GlobalStore.dispatch(
				STORE_ACTIONS.setFlagrEvaluation({
					features: {},
					flagrResults: {},
				})
			);
			window.mixpanel.track('app_flagr_set_empty');
		}

		Sentry.captureException(err);
	}
};
